import { chakra } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Point2 } from '../../../domain/geometry/geometric-types';

type Points2ResultVisualizationProps = {
  points: Point2[];
  getPointInDomCoordinateSystem: (pointInPdf: Point2) => Point2;
};

export const Points2ResultVisualization = ({
  points,
  getPointInDomCoordinateSystem,
}: Points2ResultVisualizationProps) => {
  const pointsInDom = useMemo<Point2[]>(
    () => points.map((point) => getPointInDomCoordinateSystem(point)),
    [getPointInDomCoordinateSystem, points]
  );

  return (
    <chakra.svg
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      opacity={0.8}
    >
      {pointsInDom.map((point, index) => (
        <chakra.circle
          key={index}
          cx={point[0]}
          cy={point[1]}
          r="6"
          fill="teal.400"
          stroke="teal.600"
          strokeWidth="2"
        />
      ))}
    </chakra.svg>
  );
};
